module.exports = __webpack_public_path__ + "5d3603691e51a36c473c8246b7c60f7c.jpg";